import { render, staticRenderFns } from "./BookingInfo.vue?vue&type=template&id=eb10e40a&"
import script from "./BookingInfo.vue?vue&type=script&lang=js&"
export * from "./BookingInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports